import styles from './ChatbotOverlay.module.scss';

export interface ChatbotOverlayProps extends React.PropsWithChildren {}

/**
 * ChatbotOverlay
 *
 * A component that displays a chatbot overlay.
 *
 * @param {ChatbotOverlayProps} props - The props for the ChatbotOverlay component.
 *
 * @returns A React component that displays a chatbot overlay.
 */
export const ChatbotOverlay = (props: ChatbotOverlayProps) => {
    return <div className={styles.root}>{props.children}</div>;
};
